export default "__VITE_ASSET__86724a6c__"